// extracted by mini-css-extract-plugin
export default {"title":"FasilitasPelatihan_title__A2tkl","fasilitasItems":"FasilitasPelatihan_fasilitasItems__DpzkD","fasilitasItem":"FasilitasPelatihan_fasilitasItem__9YLxN"};